// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__19-ih","range":"MonthRangeSwitch_range__21oLx","disabled":"MonthRangeSwitch_disabled__Sg2p6"};